import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import api from '../services/api';

/**
 * Componente para concluir pedidos - Funcionalidade administrativa
 */
const ConclusaoModal = ({ 
  isOpen, 
  onClose, 
  pedido, 
  onConclusionSuccess 
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      setSubmitting(true);
      
      const response = await api.patch(`/pedidos/${pedido.idProduto}/conclude`);
      
      if (response.data.success) {
        setSuccess('Pedido concluído com sucesso!');
        setTimeout(() => {
          onConclusionSuccess(response.data.data);
          onClose();
        }, 1500);
      } else {
        setError(response.data.message || 'Erro ao concluir pedido');
      }
      
    } catch (error) {
      console.error('Erro ao concluir pedido:', error);
      setError(error.response?.data?.message || 'Erro interno do servidor');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Concluir Pedido</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={submitting}
          >
            ✕
          </button>
        </div>

        <div className="mb-4 p-3 bg-gray-50 rounded">
          <p className="text-sm text-gray-600">
            <strong>Pedido:</strong> #{pedido?.idProduto}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Valor:</strong> R$ {pedido?.valor && !isNaN(pedido.valor) ? Number(pedido.valor).toFixed(2) : '0,00'}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Status Atual:</strong> {pedido?.status}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Pago:</strong> {pedido?.pagoTexto || 'Não'}
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded">
            {error}
          </div>
        )}

        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-600 rounded">
            {success}
          </div>
        )}

        <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
          <p className="text-sm text-yellow-800">
            <strong>Atenção:</strong> Esta ação marcará o pedido como concluído. 
            Certifique-se de que todos os itens foram entregues antes de prosseguir.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting && <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />}
              {submitting ? 'Processando...' : 'Concluir Pedido'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConclusaoModal;
